/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/url/GetFileNameFromURL.ts
 * @create:      2025-06-28 09:09:49.055
 * @modify:      2025-07-11 21:19:12.803
 * @version:     6.0.0
 * @times:       10
 * @lines:       53
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { Strings_Slash } from "../const/Strings";
import { RemoveQueryFromURL } from "./RemoveQueryFromURL";

/**
 * Extracts the file name from a given URL string.
 *
 * This function removes any query parameters from the URL and then returns the substring
 * after the last slash (`/`), which is typically the file name.
 *
 * @param url - The URL string from which to extract the file name.
 * @returns The file name extracted from the URL.
 * 
 * @since 1.1.7
 * @version 2018-08-30
 */
export function GetFileNameFromURL(url: string) {
    url = RemoveQueryFromURL(url);

    return url.substring(url.lastIndexOf(Strings_Slash) + 1);
}
